import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

const LogoDarkBlue = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          logoDarkBlue: file(relativePath: { eq: "logo-darkblue.png" }) {
            childImageSharp {
              fluid(maxWidth: 501) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <>
            <Img
              fluid={data.logoDarkBlue.childImageSharp.fluid}
              alt="I know a guy reovations."
            />
          </>
        )
      }}
    />
  )
}

export default LogoDarkBlue
